export default __webpack_public_path__ + "static/media/money-back@2x.3441a2f6.png";